import { TabBar } from '@ksyos/design-system';

interface ISettingsCategoryFilterButtonRowProps<T> {
    collection: (T & { displayText: string })[];
    onClick: (item: T) => void;
    selectedItem?: T;
}

export function SettingsCategoryFilterButtonRow<T extends { id: string }>(
    props: ISettingsCategoryFilterButtonRowProps<T>
) {
    return (
        <TabBar sx={{ mb: 8 }}>
            {props.collection.map((item) => (
                <TabBar.Button
                    isSelected={props.selectedItem?.id === item.id}
                    key={item.id}
                    onClick={() => props.onClick(item)}
                >
                    {item.displayText}
                </TabBar.Button>
            ))}
        </TabBar>
    );
}
